import { useQuery } from "react-query";
import * as summariesService from "api/services/summaryService";

/**
 * Store server's state of project results
 *
 * @param {summariesService.SummaryPayload} payload The summary request payload of the project results being fetched
 *
 * @returns The query object returned by the useQuery hook
 */
export const useProjectsData = (payload) =>
  useQuery(["projects", payload], () => summariesService.getProjects(payload), {
    select: ({ data }) => {
      if (!data || data.length === 0) {
        return [];
      }

      return data.flatMap(
        ({
          internalId,
          startDate,
          constructionEndDate,
          financingEndDate,
          funding,
          scopeOfWork,
          objectives,
          ...project
        }) => {
          let description = "";

          if (scopeOfWork && objectives) {
            description = `${scopeOfWork}\n\n${objectives}`;
          } else if (scopeOfWork) {
            description = scopeOfWork;
          } else if (objectives) {
            description = objectives;
          }

          return {
            ...project,
            funding,
            internalId: internalId ?? "None",
            startDate,
            constructionEndDate,
            financingEndDate,
            ...funding?.reduce(
              (fundings, { year, fundingApplied }) => ({
                ...fundings,
                [`funding${year}`]: fundingApplied,
              }),
              {}
            ),
            description,
            scopeOfWork,
            objectives,
          };
        }
      );
    },
    enabled: !!Object.keys(payload)?.length,
  });
